export default __webpack_public_path__ + "static/media/SafariRay.2f1afa7b.jpg";